/**
 * Public error code the compose-message endpoint returns when the record context or the model did
 * not answer in time. Shared here so the browser can tell a timeout from a failure.
 */
export const COMPOSE_MESSAGE_UPSTREAM_TIMEOUT_CODE = 'prompt-bridge-066';
